interface StatTileProps {
  label: string;
  value: string;
  sub?: string;
  tone?: 'navy' | 'light';
  /** 0–100+; draws a thin progress rail under the number when present. */
  progress?: number;
}

/**
 * A headline number. The form heuristic says a single magnitude with no
 * comparison is a stat tile, not a chart — these carry the month totals.
 */
export function StatTile({ label, value, sub, tone = 'light', progress }: StatTileProps) {
  const navy = tone === 'navy';
  return (
    <div
      className={`rounded-2xl p-4 ${
        navy ? 'bg-conduril' : 'border border-conduril-border bg-white shadow-card'
      }`}
    >
      <div
        className={`text-[10px] font-semibold uppercase tracking-[0.14em] ${
          navy ? 'text-[#94a1dd]' : 'text-conduril-muted'
        }`}
      >
        {label}
      </div>
      <div
        className={`num mt-2.5 text-[27px] font-semibold leading-none ${
          navy ? 'text-white' : 'text-conduril-ink'
        }`}
      >
        {value}
      </div>
      {sub && (
        <div className={`mt-1.5 text-[11px] ${navy ? 'text-[#b3bce8]' : 'text-conduril-muted'}`}>
          {sub}
        </div>
      )}
      {progress !== undefined && (
        <div
          className={`mt-3 h-1.5 overflow-hidden rounded-full ${navy ? 'bg-white/20' : 'bg-conduril-tint'}`}
        >
          <div
            className={`h-full rounded-full ${navy ? 'bg-white' : 'bg-conduril'}`}
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      )}
    </div>
  );
}
